import React from 'react'

const Spacer = () => (
  <div
    style={{
      width: 15,
      display: 'inline-block',
    }}
  />
)

export default Spacer



// WEBPACK FOOTER //
// ./components/spacer.js